import { CheckCircle2 } from "lucide-react";

/**
 * Friendly empty state used across the customer experience.
 * Never show a blank table — always show tone + CTA when there's nothing to do.
 */
export default function EmptyState({ icon: Icon = CheckCircle2, tone = "success", title, description, action, testId }) {
  const toneClass = {
    success: "text-emerald-500",
    neutral: "text-slate-400",
    info: "text-sky-500",
    warn: "text-amber-500",
  }[tone] || "text-slate-400";

  return (
    <div data-testid={testId} className="py-10 px-6 text-center flex flex-col items-center gap-3">
      <div className={`h-11 w-11 rounded-full bg-slate-50 grid place-items-center ${toneClass}`}>
        <Icon className="h-5 w-5" strokeWidth={1.6} />
      </div>
      <div>
        <div className="text-sm font-semibold text-slate-800">{title}</div>
        {description && <div className="text-xs text-slate-500 mt-1 max-w-md mx-auto leading-relaxed">{description}</div>}
      </div>
      {action}
    </div>
  );
}
